import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const headingStyles: RichtextAdapterProps["customStyles"] = {
  heading: {
    mb: { base: 6, lg: 0 },
  },
  link: {
    fontSize: "lg",
    _visited: {},
    fontWeight: { base: "normal", lg: "medium" },
  },
};

const itemTextStyles: RichtextAdapterProps["customStyles"] = {
  paragraph: { fontSize: "md" },
};

export { headingStyles, itemTextStyles };
